import { css } from "../../utils/styledComponents";
const dracula = css `
  :root {
    --ag-border-color: var(--input-border);
    --ag-row-border-color: var(--input-border);
    --ag-background-color: var(--background-accent);
    --ag-header-background-color: var(--background-top-app-bar);
    --ag-odd-row-background-color: var(--background-color-2);
    --ag-row-hover-color: var(--background-color-1);
    /* --ag-column-drop-horizontal-background-color: var(--background-top-app-bar);
    --ag-column-drop-cell-background-color: var(--input-background); */
  }
  .ag-theme-balham-dark .ag-column-drop-horizontal {
    background-color: var(--background-top-app-bar);
  }

  .ag-theme-balham-dark .ag-column-drop-cell {
    background-color: var(--input-background);
  }
`;
export default dracula;
